import { Hint } from '@systemeio/ui'
import React, { FC, PropsWithChildren, ReactNode } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { WalletIcon } from '@systemeio/ui/icons'

type PricePlanBaseProps = {
  additionalChild?: ReactNode
}

const PricePlanBase: FC<PropsWithChildren<PricePlanBaseProps>> = ({
  children,
  additionalChild,
}) => {
  const { t } = useLocoTranslation()
  return (
    <div className="flex flex-col gap-3 lg:gap-2">
      <div className="flex flex-col justify-between gap-3 lg:flex-row lg:items-center lg:gap-0">
        <div className="bo-color-[rgb(var(--brand-primary-subtle))] flex flex-col gap-3">
          <div className="text-text-primary flex flex-row items-center gap-1 text-sm font-normal lg:text-[15px]">
            <WalletIcon className={'fill-text-primary h-6 w-6 scale-75'} />
            <Hint label={t('dashboard.funnel.configuration.offer.price_plans_description')}>
              {t('dashboard.funnel.configuration.offer.price_plans')}
            </Hint>
          </div>
        </div>
        {additionalChild}
      </div>
      {children}
    </div>
  )
}

export default PricePlanBase
